import axios from 'axios';
import { apiUrl } from './lt-api';

const defaultHeaders = {
  crossDomain: true,
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
    withCredentials: true,
  },
};

const getConfigWithToken = () => {
  const token = JSON.parse(localStorage.getItem('token'));
  return {
    ...defaultHeaders,
    headers: {
      ...defaultHeaders.headers,
      Authorization: token ? `Bearer ${token}` : undefined,
    },
  };
};

export const getUsersApi = () => axios({
  ...getConfigWithToken(),
  method: 'GET',
  url: `${apiUrl}users/admin`,
});
